import { AccountTree, FindInPage } from '@mui/icons-material';
import { Box } from '@mui/material';
import React, { forwardRef } from 'react';

export const SearchIcon = forwardRef<SVGSVGElement, React.ComponentProps<typeof AccountTree>>(
  (properties, reference) => {
    return (
      <Box sx={{ transform: 'scaleX(-1)', display: 'flex' }}>
        <FindInPage ref={reference} {...properties} style={{ transform: 'scaleX(-1)', ...properties.style }} />
      </Box>
    );
  }
);

SearchIcon.displayName = 'SearchIcon';
